import React from "react"
import "./src/styles/globals.css"

export const wrapPageElement = ({ element }: { element: React.ReactElement }) => {
  return element
}